import { MapPin } from 'lucide-preact'
import { text } from '#contract'
import { useT } from '../../i18n/index.ts'
import { ShopApp } from './shop/shop-app.tsx'
import type { ShopSkin } from './shop/shop-context.ts'
import styles from './shop-skins.module.css'
import type { OsAppProps } from './types.ts'

/** The delivery address in a pill, as the brand on Grub Food's green bar. */
function GrubFoodBrand() {
  const t = useT()
  return (
    <span class={styles.pill}>
      <MapPin aria-hidden="true" />
      <span class={styles.pillLabel}>{t(text('shop.deliverTo'))}</span>
      {t(text('shop.home'))}
    </span>
  )
}

const GRUB_FOOD: ShopSkin = {
  app: 'grubfood',
  vendor: 'grubfood',
  brand: GrubFoodBrand,
  headline: text('os.app.grubfood.headline'),
  home: 'cards',
  sectionsTitle: text('shop.restaurants'),
  class: styles.grubfood,
}

/** Grub Food (a GrabFood parody): restaurants as cards, each a page of its dishes. */
export function GrubFoodApp({ os }: OsAppProps) {
  return <ShopApp os={os} skin={GRUB_FOOD} />
}
